import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";
import { uploadImages } from "../../utils/uploadFiles";

const getContacts = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.CONTACTS);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.CONTACTS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const fetchContactDetails = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.CONTACT + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.CONTACT_DETAILS,
                payload: res.data,
            });
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};

const deleteContact = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.DELETE_CONTACT + id);
    if (res.success) {
        dispatch(getContacts());
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { getContacts, fetchContactDetails, deleteContact };
